module.exports = __webpack_public_path__ + "img/logo-light.dabf7c67.jpg";